module.exports = __webpack_public_path__ + "img/collection-diamondJewelryEarrings.8cbbfde.webp";